import React from "react";

import { Helmet } from "react-helmet";
import images from "../data/images";
import CustomCarousel from "../Components/Customslider";

const OurPortfolio = () => {
  return (
    <div className="portfolio-img">
      {/* <Helmet>
        <title>Our Portfolio | Pravisht Digital - Creative Excellence</title>
        <meta
          name="description"
          content="Explore Pravisht Digital's portfolio showcasing creative excellence and innovative projects across industries."
        />
        <meta
          name="keywords"
          content="Pravisht Digital portfolio, creative projects, software development, digital solutions, case studies"
        />
        <meta property="og:title" content="Our Portfolio | Pravisht Digital" />
        <meta
          property="og:description"
          content="Explore Pravisht Digital's portfolio showcasing creative excellence and innovative projects across industries."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={images[0]?.imgURL || ''} />
        <meta name="author" content="Pravisht Digital" />
      </Helmet> */}
      <div className="portfolio-header">
        <p>OUR PORTFOLIO</p>
        <h1>Explore Our Journey of Creative Excellence</h1>
        <hr className="portfolio-horizontalline" />
      </div>

      <CustomCarousel>
        {images.map((image, index) => {
          const isEven = index % 2 === 0;
          const textColorClass = isEven ? "white-text" : "black-text";
          const layoutClass = isEven ? "portfolio-layout-left" : "portfolio-layout-right";

          return (
            <div key={index} className={`carousel-slide-wrapper ${layoutClass}`}>
              {/* Image Block */}
              <div className="portfolio-img-block">
                <img src={image.imgURL} alt={image.imgAlt} className="imgportfolio" />
                {(image.heading || image.desc) && (
                  <div className={`image-overlay-text ${textColorClass}`}>
                    {image.desc && <p>{image.desc}</p>}
                    {image.heading && <h3>{image.heading}</h3>}
                  </div>
                )}
              </div>

              {/* Extra Description Block */}
              {image.extraDesc && (
                <div className="portfolio-extra-desc-block">
                  <p>{image.extraDesc}</p>
                </div>
              )}
            </div>
          );
        })}
      </CustomCarousel>

      <button className="Portfolio-seeallprioject-btn">SEE ALL PROJECT</button>
    </div>
  );
};

export default OurPortfolio;
